import { render, staticRenderFns } from "./DeliveryTransformator.vue?vue&type=template&id=49377823&scoped=true"
import script from "./DeliveryTransformator.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryTransformator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DeliveryTransformator.vue?vue&type=style&index=0&id=49377823&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49377823",
  null
  
)

export default component.exports